import { PAGE_LEVEL_ERROR, UPDATE_USER } from "./../store/types";
import { DispatchContext } from "../store/context";
import { useState, useContext } from "react";
import API from "../network";
import { connectChatSocket } from "../config/socketService";

export const useAuth = () => {
  const [response, setResponse] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useContext(DispatchContext);

  const execute = async (username: string, password: string = "") => {
    setLoading(true);

    try {
      let response;

      if (password === "" || password === null) {
        console.log("This is refresh token");
        response = await API.post("/api/refresh-token", { username });
      } else {
        console.log("This is Login token");
        response = await API.post("/api/login", { username, password });
      }
      setLoading(false);
      console.log("useAuth: ", response);
      setResponse(response);
      if (response.status === 200) {
        const {
          token = "",
          status,
          message = "Something went wrong. Try again",
          is_first_login,
          is_manually_created,
        } = response.data;

        if (status === "error") {
          if (response?.data?.code === -1) {
            localStorage.setItem("terminate-session", "true");
          }
          dispatch({
            type: PAGE_LEVEL_ERROR,
            payload: { message },
          });
          return;
        }

        if (!token) {
          dispatch({
            type: PAGE_LEVEL_ERROR,
            payload: { message: "Invalid token. Please try again" },
          });
          return;
        }
        dispatch({ type: UPDATE_USER, payload: response.data });
        dispatch({ type: PAGE_LEVEL_ERROR, payload: null });
        localStorage.setItem("token", token);
        localStorage.setItem("is_first_login", is_first_login);
        localStorage.setItem("is_manually_created", is_manually_created);
        connectChatSocket(token);
        return true;
      } else {
        const { message = "" } = response.data;
        dispatch({ type: PAGE_LEVEL_ERROR, payload: { message } });
        return false;
      }
    } catch (error: any) {
      console.log("error: ", response);
      dispatch({
        type: PAGE_LEVEL_ERROR,
        payload: { message: response?.data?.message || error.message },
      });
      return false;
    }
  };

  return { execute, response, loading };
};
